export default "__VITE_PUBLIC_ASSET__8f1589bc__"